// extracted by mini-css-extract-plugin
module.exports = {"workspaceDueDate":"workspaceDueDate__qeJ0L"};